import React, { useContext } from 'react'
import { FetchError } from '../api/useGet'
import { Context as AnalyticsContext } from '../analytics'


interface Props {
  urlToken?: string
  error: FetchError
}


export const ErrorAnalytics: React.FC<Props> = ({ error }) => {

  const analytics = useContext(AnalyticsContext)
  const { message } = error
  const params = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    event_label: window.location.href,
    value: message
  }
  analytics.error('error', params)  

  return null
}
